<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    value?: string
    format?: string
    locale?: string
  }>(),
  {
    format: 'LL',
  }
)
const dayjs = useDayjs()

console.log(props.value, 'utc' in dayjs)

const formattedDate = computed(() => {
  try {
    return props.value
      ? props.locale
        ? dayjs(props.value).locale(props.locale).format(props.format)
        : dayjs(props.value).format(props.format)
      : undefined
  } catch (error) {
    return props.value
  }
})

const isoDate = computed(() => {
  try {
    return props.value ? dayjs.utc(props.value).toISOString() : undefined
  } catch (error) {
    return props.value
  }
})
</script>

<template>
  <time :datetime="isoDate" :title="formattedDate">
    {{ formattedDate }}
  </time>
</template>
